import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface PoppyBadgeProps {
  className?: string;
}
export const PoppyBadge: React.FC<PoppyBadgeProps> = t0 => {
  const $ = _c(4);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition-shadow duration-200 hover:shadow-md ${className}`;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>Built with Poppy</span>;
    t4 = <span className="text-red-300">❤️</span>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <a className={t2} href="https://getpoppy.ai" target="_blank">{t3}{t4}</a>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
};
export default PoppyBadge;